/**
 * heivol-id login gate (portal-spec §0). Shown only when the portal talks to the
 * real API and there is no stored JWT. The token exchange itself is done by the
 * API BFF (POST /auth/token) — this screen just kicks off the authorization-code
 * redirect through id.heivol.com's /oidc-login shim, mirroring heivol-connect.
 *
 * The confidential client_secret is NEVER in the browser; only the public
 * client_id + the authorize URL are.
 */
import { Button, Card } from '../components/ui';

const ISSUER =
  (import.meta.env['VITE_HEIVOL_ID_ISSUER'] as string | undefined) ?? 'https://id.heivol.com';
const CLIENT_ID =
  (import.meta.env['VITE_HEIVOL_ID_CLIENT_ID'] as string | undefined) ?? 'locker-app';

function randomState(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

function startLogin(): void {
  const state = randomState();
  sessionStorage.setItem('oidc_state', state);
  const redirectUri = `${window.location.origin}/auth/callback`;
  const authorizeUrl =
    `${ISSUER}/authorize?client_id=${encodeURIComponent(CLIENT_ID)}` +
    `&redirect_uri=${encodeURIComponent(redirectUri)}` +
    `&response_type=code` +
    `&scope=${encodeURIComponent('openid profile email')}` +
    `&state=${encodeURIComponent(state)}`;
  window.location.href = `${ISSUER}/oidc-login?next=${encodeURIComponent(authorizeUrl)}`;
}

export function Login() {
  return (
    <div className="grid min-h-full place-items-center p-4">
      <Card className="w-full max-w-sm space-y-5">
        <div className="flex items-center gap-2">
          <span className="grid h-8 w-8 place-items-center rounded-md bg-accent text-sm font-semibold text-white">
            H
          </span>
          <h1 className="text-lg font-semibold text-text">Heivol Locker</h1>
        </div>
        <p className="text-sm text-text-secondary">
          Sign in with your HeivolID to reach your vault. Your vault passphrase is separate — we
          never see it.
        </p>
        <Button type="button" onClick={startLogin} className="w-full">
          Sign in with HeivolID
        </Button>
      </Card>
    </div>
  );
}
